import axios from "axios";
import axiosRetry from "axios-retry";
import { errorNotifier } from "./interceptors";

const ServerApi = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE,
  withCredentials: true,
  crossDomain: true,
  insecureHTTPParser: true,
  timeout: 15000,
});

export const SafeServerApi = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE,
  withCredentials: true,
  crossDomain: true,
  insecureHTTPParser: true,
  timeout: 15000,
});

axiosRetry(ServerApi, {
  retryDelay: axiosRetry.exponentialDelay,
  retries: 2,
});

ServerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    errorNotifier(error);
  },
);

SafeServerApi.interceptors.response.use(
  (response) => response,
  (error) => errorNotifier(error, true),
);

export default ServerApi;
